import Cookies from "js-cookie";
import birdIcon from "@/assets/appLogo/birdIcon.png";
import cloudSeeIcon from "@/assets/appLogo/cloudSeeIcon.png";
import philipsIcon from "@/assets/appLogo/philipsIcon.png";
import aiSeeIcon from "@/assets/appLogo/aiSeeIcon.png";
import ystIcon from "@/assets/appLogo/ystIcon.png";
import homeIcon from "@/assets/appLogo/homeIcon.png";
import happyIcon from "@/assets/appLogo/happyIcon.png";

const headerKey = "cloudSeeHeader";
const langKey = "langKey";

export function getLang() {
  return Cookies.get(langKey);
}
export function setLang(header) {
  return Cookies.set(langKey, header);
}

export function getHeader() {
  return Cookies.get(headerKey);
}
export function setHeader(header) {
  return Cookies.set(headerKey, header);
}

export function changeFavicon(newIconPath) {
  const existingLink = document.querySelector("link[rel*='icon']"); // 检查是否已存在图标链接。
  if (existingLink) {
    // 如果存在，则移除它。
    document.head.removeChild(existingLink);
  }
  const link = document.createElement("link"); // 创建新的图标链接。
  // link.type = "image/x-icon";
  // link.rel = "shortcut icon";
  link.type = "image/png"; // PNG修正
  link.rel = "icon";
  link.href = newIconPath;
  document.getElementsByTagName("head")[0].appendChild(link); // 添加到<head>中。
}

/***
 *
 * 设置国际化语言
 * lang 语言  isEn：是否只有英文  true 是   fasle 否
 */
export function setI18nLang(lang, isEn = true) {
  let locale;
  // // 已适配的多语言
  let langArr = ["en", "es", "id", "pt", "th", "vi", "ru"];
  if (
    (lang && lang.toLocaleLowerCase() == "zh") ||
    (lang && lang.toLocaleLowerCase() == "ch") ||
    (lang && lang.toLocaleLowerCase() == "cn") ||
    (lang && lang.toLocaleLowerCase() == "tc")
  ) {
    locale = "zh";
  } else {
    locale = isEn ? "en" : langArr.includes(lang) ? lang : "en";
  }
  return locale;
}

// 判断是ios还是安卓
export function getIosOrAnd() {
  let params = "isAndroid";
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    params = "isAndroid";
  } else if (isiOS) {
    params = "isiOS";
  }
  return params;
}

/**
 *  tallAppHandle 通知app方法
 * eventName: 通知app事件名称
 * params: 传递的参数
 *
 */
export function tallAppHandle(eventName, params) {
  if (getIosOrAnd() == "isAndroid") {
    window.webkit?.[eventName](params);
  } else {
    window.webkit?.messageHandlers[eventName].postMessage(
      params
        ? params
        : {
            test: getIosOrAnd(),
          }
    );
  }
}

// 根据appkey转换appid
export function appkeyByappIdHandle(appkey) {
  // 1-千鸟，2-开心看，3-云看看，4-飞利浦，5-安芯看看，6-萤视通，7-明眸看家
  let appObj = {
    "com.dayunlinks.cloudbirds": 1,
    "com.cloudbirds.hm": 1,
    "com.dayunlinks.hapseemate": 2, 
    "com.dayunlinks.HapSeeMatecn": 2,
    "com.zhongsuo.tteyes": 3, 
    "com.iot.iot360": 3, 
    "com.tphp.philips.iot": 4,
    "com.cloudbirds.aisee": 5,
    "com.ruitongkanjia.vcam360": 6,
    "com.iot.mimopro": 7,
  };
  if (appkey) {
    return appObj[appkey.toLocaleLowerCase()]
      ? appObj[appkey.toLocaleLowerCase()]
      : 1;
  } else {
    return 1;
  }
}

/**
 * appId 映射 应用名称、图标
 */
export const appIdIconMap = {
  1: {
    name: "千鸟物联",
    icon: birdIcon
  },
  2: {
    name: "开心看Pro",
    icon: happyIcon
  },
  3: {
    name: "云看看",
    icon: cloudSeeIcon
  },
  4: {
    name: "飞利浦家庭摄像机",
    icon: philipsIcon
  },
  5: {
    name: "安芯看看",
    icon: aiSeeIcon
  },
  6: {
    name: "萤视通",
    icon: ystIcon
  },
  7: {
    name: "明眸看家",
    icon: homeIcon
  }
};